import React, { Component, useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Row,
} from "reactstrap"

import InvoiceOrders from "../../../components/Common/GenerateInvoice/index"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import InvoiceModal from "pages/Customers/invoiceModal";
import { getCustomerDetails } from "helpers/fakebackend_helper";
// class InvoiceHistory extends Component {

const GenerateInvoice = (prop) => {

    const [config, setConfig] = useState({ user: {}, isOpen: true })
    const [orders, setOrders] = useState(null)
    const [modal, setModal] = useState(false);
    const [customer, setCustomer] = useState(null)

    useEffect(async() => {
        const user = JSON.parse(localStorage.getItem("authUser")).user;
        
        setConfig({ user: user, isOpen: false })
        const customer = await getCustomerDetails(user._id);
        setCustomer(customer.data)
    }, [])

    const toggleModal = () => {
        setModal(!modal)
    }
    const handlerows = (row) => { 
        setOrders(row);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Generate Invoice | Generate Invoice Section</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Generate Invoice" breadcrumbItem="Generate Invoice" />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <InvoiceOrders match={""} orderObject={config.user} handlerows={handlerows} isOpen={config.isOpen} />
                                    <Button type="button" onClick={() => toggleModal()}>Generate Invoice</Button>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        {orders && customer && modal ? (<InvoiceModal isOpen={modal} toggle={toggleModal} processData={customer} invoiceItems={orders} />) : "" }
                        {/*  */}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )

}

export default GenerateInvoice;
